import { axios } from '@/axios.config';
import { mockAdapter } from '@/mocks/axiosMockAdapter.config';
import { handleByPermission } from '@/permissions';

export const state = {
  data: [],
  loading: false,
  error: null,
};

export const actions = {
  fetchAnnouncements({ commit }) {
    const url = `announcements`;

    mockAdapter(axios, 'get', url, 'getAnnouncements', 200);

    commit('fetchStart');

    return axios
      .get(url)
      .then(res => {
        commit('updateAnnouncements', res.data);
        commit('fetchSucceed');

        // commit('updateStatus', statusMock);
      })
      .catch(err => {
        commit('fetchFailed');
        throw err;
      });
  },
};

export const mutations = {
  fetchStart(state) {
    state['loading'] = true;
    state['error'] = null;
  },

  fetchSucceed(state) {
    state['loading'] = false;
  },

  fetchFailed(state) {
    state['loading'] = false;
    state['error'] = true;
  },

  updateAnnouncements(state, data) {
    state.data = data;
  },
};

export const getters = {
  /**
   * All announcements data.
   * RBAC filter for type=invoice: ReadInvoice
   * @param state
   * @return { array }
   */
  getAllAnnouncements(state) {
    const data = state.data;

    // Filter by permission.
    const permissionType = 'ReadInvoice';
    if (!handleByPermission(permissionType)) {
      return data.filter(item => item.type !== 'invoice');
    } else {
      return data;
    }
  },

  /**
   * Info, Invoice data.
   * RBAC filter for type=invoice: ReadInvoice
   * @param state
   * @return { array }
   */
  getFilteredAnnouncements(state) {
    const data = state.data.filter(item => item.type === 'info' || item.type === 'invoice');

    // Filter by permission.
    const permissionType = 'ReadInvoice';
    if (!handleByPermission(permissionType)) {
      return data.filter(item => item.type !== 'invoice');
    } else {
      return data;
    }
  },

  /**
   * Info, Invoice data (Limitation 3)
   * @param state
   * @param getters
   * @return { array }
   */
  getFilteredAnnouncementsLimit(state, getters) {
    const data = getters.getFilteredAnnouncements;
    const limit = 3;

    return data.slice(0, limit);
  },

  /**
   * Urgent announcements data
   * @param state
   * @return { object[] }
   */
  getUrgentAnnouncements(state) {
    const data = state.data.filter(item => item.type === 'urgent');

    if (!data.length) return [];

    return data;
  },

  /**
   * Urgent data (Limitation 1)
   * @param state
   * @return { object }
   */
  getUrgent(state) {
    const data = state.data.filter(item => item.type === 'urgent');

    if (!data.length) return null;

    return data.slice(0, 1)[0];
  },
};
